import React from 'react'
import {GoogleMap, Marker, Polygon} from 'react-google-maps'
import MapsProvider from '@components/MapsProvider'
import getFileCDNUrl from '@helpers/misc/getFileCDNUrl'
import {useRouter} from 'next/router'

import calculateCenter from '../utils/calculateCenter'

import styles from './styles.module.css'

const iconSize = 25

export default function Map({stores, map, icon, selectedStore, color, homeLocation}) {
  const router = useRouter()
  return (
    <MapsProvider containerElementClassName={styles.mapContainer}>
      <GoogleMap
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        fullScreenControl={false}
        clickableIcons={true}
        defaultZoom={15}
        defaultCenter={homeLocation ? homeLocation : calculateCenter(stores)}
        ref={renderedMap => {
          map.current = renderedMap
        }}>
        {stores && stores.length > 0
          ? stores.map((store, idx) => (
              <Marker
                key={idx}
                icon={{
                  url: icon ? getFileCDNUrl(icon) : '/images/store-in-map.svg',
                  scaledSize: {width: iconSize, height: iconSize},
                  labelOrigin: {x: iconSize / 2, y: -10},
                  anchor: {x: iconSize / 2, y: iconSize / 2}
                }}
                position={store.address.location}
                onClick={() => router.push(`/reservas/${store._id}`)}
              />
            ))
          : null}
        {homeLocation ? (
          <Marker
            icon={{
              url: '/images/icons/home.svg',
              scaledSize: {width: iconSize, height: iconSize},
              labelOrigin: {x: iconSize / 2, y: -10},
              anchor: {x: iconSize / 2, y: iconSize / 2},
              style: {color: 'red'}
            }}
            position={homeLocation}
            onClick={() => map.current && map.current.panTo(homeLocation)}
          />
        ) : null}
        {selectedStore ? (
          <>
            {selectedStore.zones.map(zone => (
              <Polygon
                key={zone._id}
                paths={zone.deliveryLimits}
                options={{
                  stokeWeight: 1,
                  fillOpacity: 0.2,
                  fillColor: color,
                  strokeColor: color
                }}
              />
            ))}
          </>
        ) : null}
      </GoogleMap>
    </MapsProvider>
  )
}
